import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

import '../styles/collection.css';

export default class CollectionController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: (props.match) ? props.match.params.collectionId : null,
      name: props.name,
      description: props.description
    };
  }

  componentDidMount() {
    if (this.state.id) {
      this.load();
    }
  }

  load() {
    const that = this;
    fetch('/api/collection/' + this.state.id, {credentials: 'same-origin', method: 'GET'})
      .then((res) => {
        res.json().then((collection) => {
          that.setState(collection);
        });
      });
  }

  save() {
    const that = this;
    const url = (this.state.id) ? `/api/collection/${this.state.id}` : '/api/collection';
    const options = {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'POST',
      body: JSON.stringify({
        description: this.state.description,
        name: this.state.name
      })
    };
    fetch(url, options).then((res) => {
      if (res.status === 201) {
        res.json().then((collection) => that.props.onSave(collection));
      }
    });
  }

  setDescription(description) {
    this.setState({description});
  }

  setName(name) {
    this.setState({name});
  }

  getForm() {
    return [
      <input key='name' type='text' onChange={(e) => this.setName(e.target.value)} placeholder='name' />,
      <TextareaAutosize key='description' onChange={(e) => this.setDescription(e.target.value)}
        rows={3}
        value={this.state.description} />];
  }

  render() {
    return (<div className='note-form'>
      <div className='note-input'>
        {this.getForm()}
      </div>
      <button onClick={(e) => this.save()}>
        <span className='glyphicon glyphicon-floppy-disk'/>
      </button>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/CollectionController.js